import { Component, OnInit, forwardRef, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { WarehouseService } from '../../_services/warehouse.service';

@Component({
  selector: 'app-warehouse-autocomplete',
  templateUrl: './warehouse-autocomplete.component.html',
  styleUrls: ['./warehouse-autocomplete.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WarehouseAutocompleteComponent),
      multi: true
    }
  ]
})
export class WarehouseAutocompleteComponent implements ControlValueAccessor {
  @Input() placeholder: any = "N'importe quel entrepôt";
  @Input() value: any;
  @Input() label: string = "";
  @Input() allowAdd: boolean = false;

  @Output() notFound: EventEmitter<string> = new EventEmitter<string>();
  @Output() valueSelected: EventEmitter<string> = new EventEmitter<string>();
  
  propagateChange = (_: any) => { };

  private warehouses: object[];
  private selected: object;
  private showResults: boolean = false;
  private noResults: boolean = false;


  constructor(private service: WarehouseService, private elRef: ElementRef) {}

  writeValue(value: any): void {
    if (value !== undefined && value !== "" && value !== null) {
      // If an Object is given, just take the ID as value
      if (value instanceof Object) {
        this.value = value.name;
        this.selected = value;
        this.elRef.nativeElement.querySelector('.warehouse').value = value.name;
      } else { // Is Not an Empty String
        this.service.getWarehouse(value).subscribe(response => {
          if (response) {
            this.selected = response;
            this.elRef.nativeElement.querySelector('.warehouse').value = response.name;
            this.value = response.name;
          } else {
            this.selected = undefined;
            this.elRef.nativeElement.querySelector('.warehouse').value = null;
            this.value = "";
          }

        });
      }
    } else {
      this.value = "";
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  changeValue(value) {
    this.propagateChange(value);
  }

  search(value) {
    this.service.autocompleteWarehouses(value || '').subscribe(response => {
      this.warehouses = response;
      this.noResults = !this.warehouses.length;
    });
  }

  ngOnInit() {
    this.changeValue(this.elRef.nativeElement.querySelector('.warehouse').value);
  }

  selectResult(warehouse) {
    if (warehouse) {
      this.elRef.nativeElement.querySelector('.warehouse').value = warehouse.name;
      this.changeValue(warehouse.id);
      this.valueSelected.emit(warehouse);
    }
  }

  onFocus() {
    this.search('');
    this.showResults = true;
  }

  onBlur(event) {
    if (this.noResults) this.triggerAdd(event.target.value)
    setTimeout(function () {
      this.showResults = false;
    }.bind(this), 200);
  }

  triggerAdd(warehouseName) {
    this.notFound.emit(warehouseName);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/warehouse-autocomplete/warehouse-autocomplete.component.ts